<template>
  <VaModal v-model="showModal" size="small" max-width="480px" hideDefaultActions mobile-fullscreen close-button>
    <template #default>
      <h1 class="va-h5 mb-4">{{ t("general.auditFields") }}</h1>
      <div class="grid-cols-2 grid gap-4">
        <InfoField
          class="col-span-1"
          :title="t('general.baseAuditableEntity.createdBy')"
          :content="props.entity?.createdBy ?? ''"
        />
        <InfoField
          class="col-span-1"
          :title="t('general.baseAuditableEntity.createdDate')"
          :content="formatDateTime(props.entity?.createdDate)"
        />
        <InfoField
          class="col-span-1"
          :title="t('general.baseAuditableEntity.modifiedBy')"
          :content="props.entity?.modifiedBy ?? ''"
        />
        <InfoField
          class="col-span-1"
          :title="t('general.baseAuditableEntity.modifiedDate')"
          :content="formatDateTime(props.entity?.modifiedDate)"
        />
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end gap-2">
        <VaButton color="secondary" @click="showModal = false">{{ t("general.close") }}</VaButton>
      </div>
    </template>
  </VaModal>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import InfoField from "./core/InfoField.vue"
import { formatDateTime } from "../helpers/utils"

const { t } = useI18n()
const showModal = defineModel<boolean>({ default: false })

const props = defineProps<{
  entity: Record<string, any> | null | undefined
}>()
</script>
